import React from "react";
import MenuSection from "../../../../components/Menu/MenuSection";
import { useSelector } from "react-redux";
import { UserContextSelectors } from "../../../../redux/selectors";
import { StateSwitcherSelector } from "../../../../components/StateSwitcher";
import SILinks from "../../../../segmentedComponents/SI-links/index";
import LiveChatMenuItem from "../../../LiveChatMenu/LiveChatMenu";
import { AppFeatures } from "../../../../constants/featureFlags";
import HelpWidgetMenu from "../../../HelpWidgetMenu/HelpWidgetMenu";
import { SettingsMobile } from "../../../../components/Settings/loader";
import { useFeature } from "../../../../hooks/useFeature";

const SecondaryMenuLayout = () => {
  const isMobile = useSelector(UserContextSelectors.isMobile);
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isVip = useSelector(UserContextSelectors.isVip);
  const isSettingsDrawerEnabled = useFeature(AppFeatures.SETTINGS_DRAWER);
  const isHelpWidgetActive = useFeature(AppFeatures.HELP_WIDGET);

  const ChatLinkIsForVipOnly = useFeature(
    AppFeatures.CHAT_LINK_IS_FOR_VIP_ONLY
  );
  const showChat = ChatLinkIsForVipOnly ? isVip : true;

  return (
    <>
      {isMobile && (
        <>
          <MenuSection className="menu-section">
            {isHelpWidgetActive ? (
              <HelpWidgetMenu />
            ) : (
              <>{showChat && isAuthenticated && <LiveChatMenuItem />}</>
            )}
            {!isAuthenticated && <StateSwitcherSelector />}
          </MenuSection>
          {isSettingsDrawerEnabled && (
            <MenuSection className="menu-section">
              <SettingsMobile />
            </MenuSection>
          )}
        </>
      )}
      {isMobile && <SILinks />}
    </>
  );
};

export default React.memo(SecondaryMenuLayout);
